export default "__VITE_ASSET__7mmwiEae__"